import React from 'react';
import { addPickMySolar } from '../../../helpers/pickMySolarHelper';

export default class SolarPageMain extends React.Component{

    render(){
        return(
            <div className="pick-my-solar">
                <pms-injectable></pms-injectable>
                {window._PMS.flush()}
            </div>
        )
    }
}